export enum HelpSection {
  ProgramOfferings = 'ProgramOfferings',
  Completeness = 'Completeness',
  BasicInfo = 'BasicInfo',
  ContactInfo = 'ContactInfo',
  HpContact = 'HpContact',
  ShareOfBusiness = 'ShareOfBusiness',
  TranslationFactors = 'TranslationFactors',
  DeviceInfo = 'DeviceInfo',
  MarketInfo = 'MarketInfo',
  FinancialAndSOB = 'FinancialAndSob',
  TopDeal = 'TopDeal',
  LongTerm = 'LongTerm',
  KeyInitiatives = 'KeyInitiatives',
  Bridges = 'Bridges',
  MDFPlanning = 'MdfPlanning',
  Graphs = 'Graphs',
  Planning = 'Planning',
  MasterDealer = 'MasterDealer', // unused
  PBMAcknowledgment = 'PbmAcknowledgment',
  ManagerAcknowledgment = 'ManagerAcknowledgment',
  PartnerAcknowledgment = 'PartnerAcknowledgment',
  HistoryAcknowledgment = 'HistoryAcknowledgment',
}
